export default "__VITE_PUBLIC_ASSET__0baa7680__"